import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Box, Grid, ListItemIcon, Typography } from '@mui/material';

import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import SettingsIcon from '@mui/icons-material/Settings';

import HostAdminActiveFalse from '../hosts/HostAdminActiveFalse';
import NotificationFrequencySettings from '../notifications/NotificationFrequencySettings';

import {
    createMyHost,
    getCurrentHost,
    toggleMyHostActiveStatus,
} from '../../actions/host';

const EditHostSettings = ({
    createMyHost,
    hostMe,
    getCurrentHost,
    toggleMyHostActiveStatus,
}) => {
    useEffect(() => {
        getCurrentHost();
    }, [getCurrentHost]);

    const changesMade = useRef(false);

    const [formData, setFormData] = useState({
        email: '',
        notificationFrequency: 7, //default to 7 days
        active: false,
    });

    useEffect(() => {
        if (hostMe) {
            setFormData({
                email: !hostMe.email ? '' : hostMe.email,
                active: !hostMe.active ? false : hostMe.active,
                notificationFrequency:
                    !hostMe.notificationFrequency &&
                    hostMe.notificationFrequency !== 0
                        ? 7
                        : hostMe.notificationFrequency, //default to 7 days
            });
        }
    }, [hostMe]);
    useEffect(() => {
        if (changesMade.current) {
            //console.log(formData);
            createMyHost(formData, true);
            changesMade.current = false;
        }
    }, [formData]);

    const { active } = formData;

    //Booking Details Dialog Functions
    const [editSettingsDialogOpen, setEditSettingsDialogOpen] = useState(false);

    const editSettingsDialogHandleClose = () => {
        setEditSettingsDialogOpen(false);
    };

    return (
        <>
            <Dialog
                open={editSettingsDialogOpen}
                onClose={editSettingsDialogHandleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                scroll="body"
                fullWidth
                maxWidth={'sm'}
                className="porchlightBG"
            >
                <DialogTitle id="alert-dialog-title">Host Settings</DialogTitle>
                <DialogContent>
                    {hostMe && hostMe.adminActive !== true && (
                        <HostAdminActiveFalse></HostAdminActiveFalse>
                    )}
                    <FormGroup
                        sx={{
                            alignItems: 'center',
                            marginTop:
                                hostMe && hostMe.adminActive !== true
                                    ? '16px'
                                    : 0,
                        }}
                    >
                        <Grid item>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={active}
                                        onChange={() =>
                                            toggleMyHostActiveStatus({
                                                active: !hostMe.active,
                                                notificationFrequency:
                                                    !hostMe.active ? 7 : 0,
                                            })
                                        }
                                        disabled={hostMe && !hostMe.adminActive}
                                    />
                                }
                                label={
                                    <Typography
                                        component={'p'}
                                        sx={{
                                            width: '100%',
                                            lineHeight: '1.3',
                                            display: 'inline-block',
                                        }}
                                    >
                                        {active ? (
                                            <>
                                                I want to be an Active Host on
                                                the Porchlight network.{' '}
                                                <span
                                                    style={{
                                                        fontSize: '.8em',
                                                        display: 'block',
                                                        color: 'var(--primary-color)',
                                                    }}
                                                >
                                                    Represent me on the map, and
                                                    show on my dashboard when an
                                                    artist is looking to book in
                                                    my area.
                                                </span>
                                            </>
                                        ) : (
                                            <>
                                                Deactive my account, for now.{' '}
                                                <span
                                                    style={{
                                                        fontSize: '.8em',
                                                        display: 'block',
                                                        color: 'var(--primary-color)',
                                                    }}
                                                >
                                                    Don’t represent me on the
                                                    map, nor consider me a host
                                                    on the Porchlight network.
                                                </span>
                                            </>
                                        )}
                                    </Typography>
                                }
                                sx={{
                                    // display: '',
                                    margin: '0',
                                    display: 'flex',
                                    alignItems: 'center',
                                    width: '100%',
                                }}
                            ></FormControlLabel>
                        </Grid>
                    </FormGroup>
                    <Box sx={{ marginTop: '16px' }}>
                        <NotificationFrequencySettings
                            hats={['HOST']}
                            hideHatLabel
                        />
                    </Box>
                </DialogContent>
            </Dialog>

            <div
                style={{
                    width: '100%',
                    padding: '8px 16px',
                    display: 'flex',
                    alignItems: 'flex-start',
                    color: 'var(--link-color)',
                }}
                onClick={() => setEditSettingsDialogOpen(true)}
            >
                <ListItemIcon
                    sx={{ minWidth: '36px', alignItems: 'flex-start' }}
                >
                    <SettingsIcon></SettingsIcon>
                </ListItemIcon>{' '}
                Host Settings
            </div>
        </>
    );
};

EditHostSettings.propTypes = {
    toggleMyHostActiveStatus: PropTypes.func.isRequired,
    getCurrentHost: PropTypes.func.isRequired,
    createMyHost: PropTypes.func.isRequired,
    hostMe: PropTypes.object,
};

const mapStateToProps = (state) => ({
    hostMe: state.host.me,
});

//export default EditHostSettings;
export default connect(mapStateToProps, {
    createMyHost,
    getCurrentHost,
    toggleMyHostActiveStatus,
})(EditHostSettings); //withRouter allows us to pass history objects
